import Util from '@/utils/util'
import {createRouter,createWebHistory,useRoute} from "vue-router";

import storeInfoFun from "../info"
import storeHomeFun from '@/home/store'
import { ElMessage } from "element-plus";



// route.beforeEach((from,to,next)=>{
//    // console.log(from)
//    // console.log(to)
//     next();
// })
// route.afterEach((from,to)=>{
//    // console.log(from)
//   //  console.log(to)
// })

var homeFuns = []
homeFuns.push(
    {
        name: "home_100",
        path: "100", 
        components:{
          homelayouts:()=>import('@/home/newstage/index.vue'),
        }
    })

for(let i = 1;i < 100;i++)
{
    homeFuns.push(
        {
            name: "home_" + i,
            path: "" + i, 
  
        })
}

var routes = [{
    name: "index",//可以简化命名,包括显示在游览器url上的，在to必须这样写:to="{'name':'abt'}"
    path: "/",
   // component: Login,
    component: () =>import(/* webpackChunkName: "about" */ "@/login/index.vue"),
    
    //linkActiveClass: 'active'
    meta:{
     
    }
},
{
    name: "login",//可以简化命名,包括显示在游览器url上的，在to必须这样写:to="{'name':'abt'}"
    path: "/login",
   // component: Login,
    component: () =>import(/* webpackChunkName: "about" */ "@/login/index.vue"),
    meta:{
        keepAlive: false
    }
    
    //linkActiveClass: 'active'
},
{
    name: "home",
    path: "/home", 
    component: () =>import(/* webpackChunkName: "about" */ "@/home/index.vue"),
    meta:{
  
    },
    children:homeFuns
},

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
  });


  router.beforeEach((to, from, next) => {
    // console.log("afterEach to",to)
    // console.log("afterEach from",from)
    if(!to)
    {
        next()
        return;
    }
 
    let storeInfo = storeInfoFun();

    if (to.path.indexOf('/home')!=-1) {
        const token = storeInfo.loadToken();
        if (Util.isEmpty(token)) {
            ElMessage({type:"error",message:"登录验证错误!"});
            storeInfo.logoutFlash = true
            next({path: '/login'})
            
        } else {
            next()
        }

    } else if(to.path == '/login' || to.path == '/')
    {
       // from.meta.keepAlive = false
       //console.log("?????????from",from)
       
        next()
    }
    else {
        next()
    }
})

router.afterEach((to, from) => {
    if(!to)
        return;
    if (to.path.indexOf('/home')!=-1) {
    
      let storeInfo = storeInfoFun();
      let storeHome = storeHomeFun();
       let route = useRoute();
    if(!route)
        return;
      setTimeout(()=>{
     
         storeInfo.catalogPageSearch(route.path,route.query,storeHome)
      },600)
    }

})

export default router;